import { Grid, GridProps } from '@mui/material';
import { styled } from '@mui/material/styles';

import { ServiceThemeOptions } from '../themes';

// Styled component for the onboarding grid items
export const OnboardGridItem = styled(Grid)<GridProps>(({ theme }) => {
  const serviceTheme = theme as ServiceThemeOptions;

  // Use new theme-aware input field colors with fallbacks
  const focusBorderColor =
    serviceTheme.custom?.inputField?.focus?.borderColor ||
    theme.palette.primary.main;
  const focusBorderWidth =
    serviceTheme.custom?.inputField?.focus?.borderWidth || '2px';
  const hoverBorderColor =
    serviceTheme.custom?.inputField?.hover?.borderColor ||
    theme.palette.primary.main;

  return {
    width: '100%',
    marginBottom: '16px',

    // Input field styling - updated to use theme variables
    '& label.Mui-focused': {
      color: focusBorderColor,
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: focusBorderColor,
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',

      '&:hover fieldset': {
        borderColor: hoverBorderColor,
      },
      '&.Mui-focused fieldset': {
        borderColor: focusBorderColor,
        borderWidth: focusBorderWidth,
      },
      '& input': {
        padding: { xs: '14px 12px', sm: '16px 12px' },
        fontSize: '16px',
        fontWeight: 400,
        letterSpacing: '0.15px',
      },
    },

    // Helper text styling
    '& .MuiFormHelperText-root': {
      marginLeft: '8px',
      marginRight: '8px',
      fontSize: { xs: '11px', sm: '12px' },
      lineHeight: { xs: '14px', sm: '15px' },
      letterSpacing: '0.4px',
    },

    // Typography styling within grid items
    '& .MuiTypography-body2': {
      fontSize: { xs: '13px', sm: '14px' },
      lineHeight: { xs: '18px', sm: '20px' },
      letterSpacing: '0.15px',
      color: theme.palette.text.secondary,
    },

    // Checkbox styling
    '& .MuiCheckbox-root': {
      color: theme.palette.text.secondary,
      '&.Mui-checked': {
        color: theme.palette.primary.main,
      },
    },

    // Form control label
    '& .MuiFormControlLabel-root': {
      marginLeft: 0,
      '& .MuiFormControlLabel-label': {
        fontSize: { xs: '13px', sm: '14px' },
        lineHeight: { xs: '18px', sm: '20px' },
        color: theme.palette.text.secondary,
      },
    },
  };
});
